import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/eye-closed.svg';
import { Icon } from '../Icon/Icon';
export const EyeClosedIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
